import script from "./Residue.vue?vue&type=script&setup=true&lang=js"
export * from "./Residue.vue?vue&type=script&setup=true&lang=js"

import "./Residue.vue?vue&type=style&index=0&id=77243e40&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77243e40"]])

export default __exports__